export enum FeatureFlag {
  ORDER_IMPORT = 'featureflag.order-import',
}

export const isEnabled = (name: FeatureFlag): boolean => localStorage.getItem(name) === 'true';

export const enable = (name: FeatureFlag) => {
  localStorage.setItem(name, 'true');
};

export const disable = (name: FeatureFlag) => {
  localStorage.removeItem(name);
};

export const isAllEnabled = (): boolean =>
  Object.keys(FeatureFlag).reduce(
    (cur, inc) =>
      cur && localStorage.getItem(FeatureFlag[inc as keyof typeof FeatureFlag]) === 'true',
    true,
  );

export const enableAll = () => {
  Object.keys(FeatureFlag).forEach((flagKey) => {
    localStorage.setItem(FeatureFlag[flagKey as keyof typeof FeatureFlag], 'true');
  });
};

export const disableAll = () => {
  Object.keys(FeatureFlag).forEach((flagKey) => {
    localStorage.removeItem(FeatureFlag[flagKey as keyof typeof FeatureFlag]);
  });
};
